import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Button         from '@mui/material/Button';
import Link           from '@mui/material/Link';
import Grid           from '@mui/material/Grid';
import Container      from '@mui/material/Container';
import Typography     from '@mui/material/Typography';
import CheckCircle    from '@mui/icons-material/CheckCircle';

import { Iterable } from 'immutable';

import { isValidURL } from 'helpers/url';

// TODO: navigate to questions scren if there are still some unanswered questions
function Completion({
  job, theme, message, redirectUrl, refreshRate, ctas,
}) {

  const text       = message && message.length > 0 ? message : t('eos.landing_page.text.completion_message', { job });
  const activeCtas = (ctas instanceof Array) ? ctas.filter((c) => c.active) : [];

  useEffect(() => {
    if (!redirectUrl || !isValidURL(redirectUrl)) return;

    const parsedDelay = Number(refreshRate);

    // NOTE: Setting a minimum of 2 seconds delay to avoid immediate transition
    // from completion screen to redirect url.
    const delaySeconds = parsedDelay > 1 ? parsedDelay : 2;

    setTimeout(() => {
      window.location.href = redirectUrl;
    }, delaySeconds * 1000);
  }, []);

  return (
    <Container>
      <Grid container sx={{ mt: 5, mb: 6, justifyContent: 'center' }}>
        <Grid
          item
          md={6}
          sm={10}
          xs={12}
          sx={{
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <CheckCircle
            color="primary"
            sx={{
              fontSize:                       60,
              [theme.breakpoints.only('xs')]: {
                fontSize: 50,
              },
            }}
          />

          <Typography variant="h5" sx={{ mt: 3, textAlign: 'center' }}>
            {text}
          </Typography>
        </Grid>
      </Grid>

      <Grid container sx={{ mt: 2, justifyContent: 'center' }}>
        <Grid
          item
          md={3}
          sm={4}
          xs={10}
          sx={{
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {
            activeCtas.map((cta) => (
              <Link key={cta.label} href={cta.url} target="_blank" rel="noopener" variant="body" underline="none" sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Button variant="contained" disableElevation color="primary" size="large" sx={{ width: '100%', textTransform: 'inherit', my: 1 }}>
                  {cta.label}
                </Button>
              </Link>
            ))
          }
        </Grid>
      </Grid>
    </Container>
  );
}

Completion.defaultProps = {
  job:         null,
  theme:       {},
  message:     null,
  redirectUrl: null,
  refreshRate: null,
  ctas:        [],
};

Completion.propTypes = {
  job:         PropTypes.string,
  theme:       PropTypes.objectOf(Iterable),
  message:     PropTypes.string,
  redirectUrl: PropTypes.string,
  refreshRate: PropTypes.string,
  ctas:        PropTypes.arrayOf(Iterable),
};

export default Completion;
